import React from "react";
import { testimonialsData } from "../../../../constants/Home/reviews";
import * as S from './Styled'

export default function Reviews() {
    const handleClick = (event) => {
        event.preventDefault();
        const formSection = document.getElementById("formulario");
        if (formSection) {
        formSection.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <S.Container>
        <S.Title>E o que estão falando?</S.Title>

        <S.CardsWrapper>
            {testimonialsData.map(({ name, role, text }, i) => (
            <S.Card key={i}>
                <S.CardContent>
                <S.Text>"{text}"</S.Text>

                <S.AuthorBox>
                    <S.AuthorName>{name}</S.AuthorName>
                    <S.AuthorRole>{role}</S.AuthorRole>
                </S.AuthorBox>
                </S.CardContent>
                <S.Stars src="https://static.meucupom.com/media/LP%20-%20Clube%20de%20beneficio/5-estrelas.png" alt="Estrelas" />
            </S.Card>
            ))}
        </S.CardsWrapper>

        <S.Button href="#formulario" onClick={handleClick}>
            ENTRE EM CONTATO AGORA
        </S.Button>
        </S.Container>
    );
}
